<script setup>
defineProps({
  buttons: {
    type: Array,
    default: () => {
      return []
    }
  },
  position: {
    type: Number,
    default: -1
  }
});

const styleSvg = (imgSvg) => {
  return {
    mask: `url(${imgSvg}) no-repeat center`
  }
}

</script>

<template>
  <div class="switch-button-group">
    <button
      v-for="(btn, index) in buttons"
      :key="index"
      type="button"
      :title="btn.title"
      :class="{ active: index === position }"
      :data:key="btn.key"
      @click="btn.callback"
    >
      <i v-if="btn.icon" :class="btn.icon" />
      <img v-if="btn.img" :src="btn.img">
      <span class="text">{{ btn.text }}</span>
    </button>
  </div>
</template>